import { WorkspaceMemberUserSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const WORKSPACE_MEMBER_USER_TABLE = 'workspaceMemberUsers'

export const WorkspaceMemberUserConfig: CollectionBuildRequestConfig = {
  collectionType: 'query',
  table: WORKSPACE_MEMBER_USER_TABLE,
  partitionKey: 'workspaceId',
  key: 'id',
  apiEndpoint: '/api/workspace/[workspaceId]/members',
  where: {},
  schema: WorkspaceMemberUserSchema,
}
